import {IGlobalStore} from 'modules/types';
import {createSelector} from 'reselect';

export const getGlobalState = ( { global }: IGlobalStore ) => global;
export const getMenuState = createSelector( getGlobalState, global => global.menuState );